import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { FiBriefcase, FiStar, FiCode } from 'react-icons/fi';

function WorkExperience({ mode }) {
  // Define theme-aware card styling
  const isDark = mode;

  const work = [
    {
      office: 'DIGITROBE',
      post: 'Frontend Developer',
      desc: 'Built responsive web interfaces with modern JavaScript and collaborated on backend integrations while refining UI performance and accessibility.',
      duration: '06/2024 – 10/2025 • Islamabad',
      icon: <FiBriefcase size={24} />,
      iconColor: '#2563eb',
    },
    {
      office: 'Robo Coding IT Sol',
      post: 'Flutter Developer Intern',
      desc: 'Designed and implemented production-ready Flutter UI flows for eCommerce, health, and messaging apps, incorporating Firebase and clean architecture.',
      duration: '10/2023 – 04/2024 • Remote',
      icon: <FiCode size={24} />,
      iconColor: '#059669',
    },
    {
      office: 'Vase Solutions',
      post: 'Frontend Web Developer Intern',
      desc: 'Delivered responsive web UI components with Bootstrap and React while contributing to design workflows and client-facing implementation reviews.',
      duration: '06/2022 – 03/2023 • Islamabad',
      icon: <FiStar size={24} />,
      iconColor: '#7c3aed',
    },
  ];

  // Colors based on current theme state
  const containerBg = isDark ? '#111827' : '#ffffff';
  const textColor = isDark ? '#ffffff' : '#0f172a';
  const arrowColor = isDark ? '7px solid #111827' : '7px solid #ffffff';
  const lineColor = isDark ? '#ffffff' : '#000000'; // Dynamic Line Color!

  return (
    <div className="container section-card py-5">
      <div className="section-heading mb-4">
        <p className="section-title">Work Experience</p>
        <p className="section-subtitle">
          A selection of professional and internship roles where I contributed to production solutions, responsive web apps, and Flutter development.
        </p>
      </div>

      <VerticalTimeline className="work-timeline" lineColor={lineColor}>
        {work.map(item => (
          <VerticalTimelineElement
            key={item.office}
            className="vertical-timeline-element--work"
            contentStyle={{
              background: containerBg,
              color: textColor,
              boxShadow: isDark
                ? '0 10px 25px rgba(0,0,0,0.3)'
                : '0 10px 25px rgba(0,0,0,0.05)',
              borderRadius: '16px',
            }}
            contentArrowStyle={{ borderRight: arrowColor }}
            date={item.duration}
            /* --- UPDATE THIS PROP BELOW --- */
            iconStyle={{
              background: item.iconColor,
              color: '#fff',
              boxShadow: isDark
                ? '0 0 0 4px #ffffff, inset 0 2px 0 rgba(0,0,0,.08), 0 3px 0 4px rgba(0,0,0,.05)'
                : '0 0 0 4px #000000, inset 0 2px 0 rgba(0,0,0,.08), 0 3px 0 4px rgba(0,0,0,.05)'
            }}
            icon={item.icon}
          >
            <h3 className="vertical-timeline-element-title mb-2" style={{ color: textColor }}>
              {item.office}
            </h3>
            <h4 className="vertical-timeline-element-subtitle fs-5" style={{ color: item.iconColor }}>
              {item.post}
            </h4>
            <p style={{ color: isDark ? '#94a3b8' : '#475569' }}>{item.desc}</p>
          </VerticalTimelineElement>
        ))}
      </VerticalTimeline>
    </div>
  );
}

export default WorkExperience;